
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.624 3.897c.048-.066.1-.146.167-.255l.14-.23.056-.093C5.54 2.415 5.942 2 6.667 2H10v1.333H6.666c-.058 0-.24.188-.54.681l-.05.08-.15.249c-.082.133-.15.237-.22.333-.298.415-.597.657-1.04.657h-2A.667.667 0 002 6v6c0 .368.298.667.666.667h10.667A.667.667 0 0014 12V8h1.333v4a2 2 0 01-2 2H2.666a2 2 0 01-2-2V6a2 2 0 012-2h1.878c.022-.025.05-.06.08-.103zm6.709 1.436V4h1.333V2.667H14V4h1.333v1.333H14v1.334h-1.334V5.333h-1.333zM8 12a3.333 3.333 0 110-6.667A3.333 3.333 0 018 12zm0-1.333a2 2 0 100-4 2 2 0 000 4z","fill":"#FFAA80"}})])
          )
        }
      }
    